import { types } from "react-bricks/frontend"

const pageTypes: types.IPageType[] = [
    {
        name: "page",
        pluralName: "pages",
        defaultLocked: false,
        defaultStatus: types.PageStatus.Draft,
        defaultLanguage: "de",
        getDefaultContent: () => [],
        excludedBlockTypes: ["TextImageBlock", "HeroArticle", "QuoteCompact", "BackToTop", "Summary"],
    },
    {
        name: "landing page",
        pluralName: "landing pages",
        defaultLocked: false,
        defaultStatus: types.PageStatus.Draft,
        defaultLanguage: "de",
        getDefaultContent: () => [],
        excludedBlockTypes: ["TextImageBlock", "HeroArticle", "QuoteCompact", "BackToTop", "Summary"],
    },
    {
        name: "article page",
        pluralName: "article pages",
        defaultLocked: false,
        defaultStatus: types.PageStatus.Draft,
        defaultLanguage: "de",
        getDefaultContent: () => [],
    },
    {
        name: "archive page",
        pluralName: "archive pages",
        defaultLocked: false,
        defaultStatus: types.PageStatus.Draft,
        defaultLanguage: "de",
        getDefaultContent: () => [],
    },
]

export default pageTypes
